var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.object && _vm.object.endereco != '')?_c('div',[_c('v-card',{staticClass:"scroll pa-0 text-center",attrs:{"max-height":"350","min-height":"350","outlined":"","id":"table_border","color":"#F0F0F0"}},[_c('iframe',{attrs:{"src":_vm.map,"height":"350","width":"100%","frameBorder":"0"}})])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }